<template>
  <div v-if="headerData && pictures" class="project-container">
    <project-header :project="headerData" :completed="false" />
    <project-carousel
      v-if="pictures?.length > 0"
      :pictures="pictures"
      :stages="stages"
      :completed="false"
      :has_many="true"
      :projectIndex="project.id"
      :inTheViewPort="true"
    ></project-carousel>
    <donorsActions :cost="this.project_type.cost" :projectId="project.id"/>
    <hr />
    <div style="margin-bottom: 1rem">
      <p>

        With your support, we will use solar energy to pump clean water from the
        underground aquifer beneath their feet. The water, once pumped, will be
        distributed through several taps that will be installed across the
        village which will drastically and permanently transform the lives of
        the villagers.
        (<a href="https://innoafrica.org/ia-water.html" target="_blank" style="color: rgb(51, 122, 183); cursor: pointer; font-style: inherit;">See</a>
        the 8 steps for the construction of the solar water
        pumping system)
      </p>
      <br>
      <p>
        100% of your donation will go to {{ project.name }} and a live remote
        monitoring will permit you to see how much water is being pumped daily.
      </p>
    </div>


<!--     <div style="margin-bottom: 1rem">
      <p>
        Your donation will enable us to install solar energy to provide light
        and/or clean water to this community.
        <a href="https://innoafrica.org/israel.html" target="_blank"
          >Click here</a
        >
        to learn more about our Israeli-developed technology.
      </p>
      <p>
        We will keep you updated throughout the process and we hope to welcome
        you to the field to celebrate with the community.
        <br />
        <br />
        Following the completion of the project, you will receive access to your
        monitoring page, where you will be able to track the amount of water
        pumped at any given moment. Should a malfunction occur, you and our team
        will receive an alert and our local engineers will be able to address it
        right away.
        <br />
        <br />

        100% of your donation will be used for this project as our overheads are
        already covered.
      </p>
    </div> -->
  </div>
</template>

<script>
import projectHeader from '../reusableComponents/ProjectHeader.vue'
import projectCarousel from '../reusableComponents/ProjectCarousel.vue'
import donorsActions from '../reusableComponents/DonorsActions.vue'
import './stylesheets/main.scss'
import axios from 'axios'
export default {
  props: {
    project: Object,
    project_type: Object,
    country: Object,
    district_name: String,
    pictures: Array,
    district_name: String,
  },
  data() {
    return {
      headerData: null,
      showPopup: false,
      stages: null,
    }
  },
  components: {
    projectHeader,
    projectCarousel,
    donorsActions,
  },
  async created() {

    let projectsStagesFetch = await axios.post('/api/project_stages', {
      index: 0,
      totalCount: 50,
      additionalColumns: ['id', 'name', 'picture_caption'],
    })
    this.stages = projectsStagesFetch.data.data
    let completedHeader = {
      project_name: this.project.name,
      description: this.project.prospective_description || '',
      population: this.project.population,
      location: {
        lat: parseFloat(this.project.latitude),
        lng: parseFloat(this.project.longitude),
      },
      project_type: {
        name: this.project_type.name,
        icon: this.project_type.icon,
        // cost: this.project_type.cost,
        cost: this.project.budget,
        timeframe: this.project_type.timeframe,
        icon: this.project_type.icon_url,
        marker_icon: this.project_type.marker_icon_url,
      },
      project_country: {
        name: this.country.name,
        id: this.country.id,
        flag_url: this.country.flag_url,
      },
      district_name: this.district_name,
    }
    this.headerData = completedHeader
  },
}
</script>
